import {useStorage} from '@vueuse/core';
import {scrollWeekIntoView} from './availability.table.service';

const SELECTED_WEEK_KEY = 'selectedWeek';
const REFRESH_AVAILABILITY_KEY = 'refreshAvailability';

export const selectedWeek = useStorage<string | null>(SELECTED_WEEK_KEY, null);

export const refreshAvailability = useStorage<boolean>(REFRESH_AVAILABILITY_KEY, false);

export const getSelectedWeek = () => selectedWeek.value || null;

export const setSelectedWeek = (week: string | null) => selectedWeek.value = week;

export const setSelectedWeekAndScroll = (week: string | null) => {
	setSelectedWeek(week);

	if (week) {
		scrollWeekIntoView(week);
	}
};

export const toggleRefreshAvailability = () => refreshAvailability.value = !refreshAvailability.value;
